export const MAX_TITLE_CHARS = 100;
export const DELETION_CONFIRMATION_DISPLAY_TIMEOUT = 2000;
